import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { SharedZoneBlocks, SharedZoneArticles } from 'store/SharedZone/blocks/selectors';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { SmartFrameSwitcher } from 'bricks';
import { Frame } from 'components';

import styles from './styles.pcss';
import VideoItem from './components/VideoItem';

const cx = classNames.bind(styles);

function Videos({ headline, list, isMobile }) {
  return (
    <div id="list" className={cx('wrapper')}>
      <div className={cx('bar')}>
        <div className={cx('headline')}>{headline}</div>
      </div>
      <div className={cx('list')}>
        <SmartFrameSwitcher
          framesPerSlide={isMobile ? 1 : 3}
          noArrows={false}
          arrowClass={cx('overriddenArrow')}
        >
          {list.map((item, index) => (
            <Frame key={+index}>
              <VideoItem key={`${item.$id}_${item.id}`} data={item} isMobile={isMobile} />
            </Frame>
          ))}
        </SmartFrameSwitcher>
      </div>
    </div>
  );
}

Videos.propTypes = {
  headline: PropTypes.string,
  list: PropTypes.array,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  headline: SharedZoneArticles.getHeadline(state),
  list: SharedZoneArticles.getList(state),
  isMobile: isScreenBelow640(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(Videos);
